//#region src/constants/carrier-options.ts
var e = {
	AbsentOnDelivery: "absent_on_delivery_note_platform_1",
	DpdNlTest: "DPD NL Test",
	PostNlPhysicalContract: "postnl_physical_contract",
	PostNlPackageSmallNl: "postnl_package_small_nl",
	DhlForYouCollectShipmentsContract: "dhl_for_you_collect_shipments_contract"
}, t = {
	PostNl: 1,
	Bpost: 2,
	CheapCargo: 3,
	Dpd: 4,
	Instabox: 5,
	Dhl: 6,
	Bol: 7,
	Ups: 8,
	DhlForYou: 9,
	DhlParcelConnect: 10,
	DhlEuroPlus: 11,
	UpsStandard: 12,
	UpsExpressSaver: 13,
	Gls: 14,
	Brt: 15,
	Trunkrs: 16,
	InPost: 17,
	PosteItaliane: 18
}, n = {
	PostNl: "postnl",
	POSTNL: "POSTNL",
	Bpost: "bpost",
	BPOST: "BPOST",
	CheapCargo: "cheapcargo",
	CHEAP_CARGO: "CHEAP_CARGO",
	Dpd: "dpd",
	DPD: "DPD",
	Instabox: "instabox",
	INSTABOX: "INSTABOX",
	Dhl: "dhl",
	BolCom: "bol.com",
	Bol: "bol",
	BOL: "BOL",
	Ups: "ups",
	UPS: "ups",
	DHL: "DHL",
	DhlForYou: "dhlforyou",
	DHL_FOR_YOU: "DHL_FOR_YOU",
	DhlParcelConnect: "dhlparcelconnect",
	DHL_PARCEL_CONNECT: "DHL_PARCEL_CONNECT",
	DhlEuroPlus: "dhleuroplus",
	DHL_EUROPLUS: "DHL_EUROPLUS",
	UpsStandard: "upsstandard",
	UPS_STANDARD: "UPS_STANDARD",
	UpsExpressSaver: "upsexpresssaver",
	UPS_EXPRESS_SAVER: "UPS_EXPRESS_SAVER",
	Gls: "gls",
	GLS: "GLS",
	Brt: "brt",
	BRT: "BRT",
	Trunkrs: "trunkrs",
	TRUNKRS: "TRUNKRS",
	InPost: "inpost",
	INPOST: "INPOST",
	PosteItaliane: "posteitaliane",
	POSTE_ITALIANE: "POSTE_ITALIANE"
}, ee = [t.Dhl, t.Instabox], te = {
	[t.PostNl]: n.PostNl,
	[t.Bpost]: n.Bpost,
	[t.CheapCargo]: n.CheapCargo,
	[t.Dpd]: n.Dpd,
	[t.Instabox]: n.Instabox,
	[t.Dhl]: n.Dhl,
	[t.Bol]: n.Bol,
	[t.Ups]: n.Ups,
	[t.DhlForYou]: n.DhlForYou,
	[t.DhlParcelConnect]: n.DhlParcelConnect,
	[t.DhlEuroPlus]: n.DhlEuroPlus,
	[t.UpsStandard]: n.UpsStandard,
	[t.UpsExpressSaver]: n.UpsExpressSaver,
	[t.Gls]: n.Gls,
	[t.Brt]: n.Brt,
	[t.Trunkrs]: n.Trunkrs,
	[t.InPost]: n.InPost,
	[t.PosteItaliane]: n.PosteItaliane
}, ne = (e) => te[e], r = {
	[t.PostNl]: n.POSTNL,
	[t.Bpost]: n.BPOST,
	[t.CheapCargo]: n.CHEAP_CARGO,
	[t.Dpd]: n.DPD,
	[t.Instabox]: n.INSTABOX,
	[t.Dhl]: n.DHL,
	[t.Bol]: n.BOL,
	[t.Ups]: n.UPS,
	[t.DhlForYou]: n.DHL_FOR_YOU,
	[t.DhlParcelConnect]: n.DHL_PARCEL_CONNECT,
	[t.DhlEuroPlus]: n.DHL_EUROPLUS,
	[t.UpsStandard]: n.UPS_STANDARD,
	[t.UpsExpressSaver]: n.UPS_EXPRESS_SAVER,
	[t.Gls]: n.GLS,
	[t.Brt]: n.BRT,
	[t.Trunkrs]: n.TRUNKRS,
	[t.InPost]: n.INPOST,
	[t.PosteItaliane]: n.POSTE_ITALIANE
}, re = (e) => r[e], i = {
	[n.PostNl]: t.PostNl,
	[n.POSTNL]: t.PostNl,
	[n.Bpost]: t.Bpost,
	[n.BPOST]: t.Bpost,
	[n.CheapCargo]: t.CheapCargo,
	[n.CHEAP_CARGO]: t.CheapCargo,
	[n.Dpd]: t.Dpd,
	[n.DPD]: t.Dpd,
	[n.Instabox]: t.Instabox,
	[n.Dhl]: t.Dhl,
	[n.BolCom]: t.Bol,
	[n.Bol]: t.Bol,
	[n.BOL]: t.Bol,
	[n.Ups]: t.Ups,
	[n.DhlForYou]: t.DhlForYou,
	[n.DHL_FOR_YOU]: t.DhlForYou,
	[n.DhlParcelConnect]: t.DhlParcelConnect,
	[n.DHL_PARCEL_CONNECT]: t.DhlParcelConnect,
	[n.DhlEuroPlus]: t.DhlEuroPlus,
	[n.DHL_EUROPLUS]: t.DhlEuroPlus,
	[n.UpsStandard]: t.UpsStandard,
	[n.UPS_STANDARD]: t.UpsStandard,
	[n.UpsExpressSaver]: t.UpsExpressSaver,
	[n.UPS_EXPRESS_SAVER]: t.UpsExpressSaver,
	[n.Gls]: t.Gls,
	[n.GLS]: t.Gls,
	[n.Brt]: t.Brt,
	[n.BRT]: t.Brt,
	[n.Trunkrs]: t.Trunkrs,
	[n.TRUNKRS]: t.Trunkrs,
	[n.InPost]: t.InPost,
	[n.INPOST]: t.InPost,
	[n.PosteItaliane]: t.PosteItaliane,
	[n.POSTE_ITALIANE]: t.PosteItaliane
}, ie = (e) => i[e], a = {
	Afghanistan: "AF",
	AlandIslands: "AX",
	Albania: "AL",
	Algeria: "DZ",
	AmericanSamoa: "AS",
	AmericanVirginIslands: "VI",
	Andorra: "AD",
	Angola: "AO",
	Anguilla: "AI",
	Antarctica: "AQ",
	AntiguaAndBarbuda: "AG",
	Argentina: "AR",
	Armenia: "AM",
	Aruba: "AW",
	Australia: "AU",
	Austria: "AT",
	Azerbaijan: "AZ",
	Bahamas: "BS",
	Bahrain: "BH",
	Bangladesh: "BD",
	Barbados: "BB",
	Belarus: "BY",
	Belgium: "BE",
	Belize: "BZ",
	Benin: "BJ",
	Bermuda: "BM",
	Bhutan: "BT",
	Bolivia: "BO",
	BonaireSintEustatiusAndSaba: "BQ",
	BosniaAndHerzegovina: "BA",
	Botswana: "BW",
	BouvetIsland: "BV",
	Brazil: "BR",
	BritishIndianOceanTerritory: "IO",
	BritishVirginIslands: "VG",
	BruneiDarussalam: "BN",
	Bulgaria: "BG",
	BurkinaFaso: "BF",
	Burundi: "BI",
	CaboVerde: "CV",
	Cambodia: "KH",
	Cameroon: "CM",
	Canada: "CA",
	CanaryIslands: "IC",
	CaymanIslands: "KY",
	CentralAfricanRepublic: "CF",
	Chad: "TD",
	Chile: "CL",
	China: "CN",
	ChristmasIsland: "CX",
	CocosIslands: "CC",
	Colombia: "CO",
	Comoros: "KM",
	CongoBrazzaville: "CG",
	CongoKinshasa: "CD",
	CookIslands: "CK",
	CostaRica: "CR",
	CoteDIvoire: "CI",
	Croatia: "HR",
	Cuba: "CU",
	Curacao: "CW",
	Cyprus: "CY",
	CzechRepublic: "CZ",
	Denmark: "DK",
	Djibouti: "DJ",
	Dominica: "DM",
	DominicanRepublic: "DO",
	DutchAntilles: "AN",
	Ecuador: "EC",
	Egypt: "EG",
	ElSalvador: "SV",
	EquatorialGuinea: "GQ",
	Eritrea: "ER",
	Estonia: "EE",
	Eswatini: "SZ",
	Ethiopia: "ET",
	FalklandIslands: "FK",
	FaroeIslands: "FO",
	Fiji: "FJ",
	Finland: "FI",
	France: "FR",
	FrenchGuiana: "GF",
	FrenchPolynesia: "PF",
	FrenchSouthernTerritories: "TF",
	Gabon: "GA",
	Gambia: "GM",
	Georgia: "GE",
	Germany: "DE",
	Ghana: "GH",
	Gibraltar: "GI",
	Greece: "GR",
	Greenland: "GL",
	Grenada: "GD",
	Guadeloupe: "GP",
	Guam: "GU",
	Guatemala: "GT",
	Guernsey: "GG",
	Guinea: "GN",
	GuineaBissau: "GW",
	Guyana: "GY",
	Haiti: "HT",
	HeardIslandAndMcdonaldIslands: "HM",
	HolySee: "VA",
	Honduras: "HN",
	HongKong: "HK",
	Hungary: "HU",
	Iceland: "IS",
	India: "IN",
	Indonesia: "ID",
	Iran: "IR",
	Iraq: "IQ",
	Ireland: "IE",
	IsleOfMan: "IM",
	Israel: "IL",
	Italy: "IT",
	Jamaica: "JM",
	Japan: "JP",
	Jersey: "JE",
	Jordan: "JO",
	Kazakhstan: "KZ",
	Kenya: "KE",
	Kiribati: "KI",
	KoreaPeoplesDemocraticRepublic: "KP",
	KoreaRepublic: "KR",
	Kosovo: "XK",
	Kuwait: "KW",
	Kyrgyzstan: "KG",
	Laos: "LA",
	Latvia: "LV",
	Lebanon: "LB",
	Lesotho: "LS",
	Liberia: "LR",
	Libya: "LY",
	Liechtenstein: "LI",
	Lithuania: "LT",
	Luxembourg: "LU",
	Macao: "MO",
	Madagascar: "MG",
	Malawi: "MW",
	Malaysia: "MY",
	Maldives: "MV",
	Mali: "ML",
	Malta: "MT",
	MarshallIslands: "MH",
	Martinique: "MQ",
	Mauritania: "MR",
	Mauritius: "MU",
	Mayotte: "YT",
	Mexico: "MX",
	Micronesia: "FM",
	Moldova: "MD",
	Monaco: "MC",
	Mongolia: "MN",
	Montenegro: "ME",
	Montserrat: "MS",
	Morocco: "MA",
	Mozambique: "MZ",
	Myanmar: "MM",
	Namibia: "NA",
	Nauru: "NR",
	Nepal: "NP",
	Netherlands: "NL",
	NewCaledonia: "NC",
	NewZealand: "NZ",
	Nicaragua: "NI",
	Niger: "NE",
	Nigeria: "NG",
	Niue: "NU",
	NorfolkIsland: "NF",
	NorthMacedonia: "MK",
	NorthernMarianaIslands: "MP",
	Norway: "NO",
	Oman: "OM",
	Pakistan: "PK",
	Palau: "PW",
	Palestine: "PS",
	Panama: "PA",
	PapuaNewGuinea: "PG",
	Paraguay: "PY",
	Peru: "PE",
	Philippines: "PH",
	Pitcairn: "PN",
	Poland: "PL",
	Portugal: "PT",
	PuertoRico: "PR",
	Qatar: "QA",
	Reunion: "RE",
	Romania: "RO",
	RussianFederation: "RU",
	Rwanda: "RW",
	SaintBarthelemy: "BL",
	SaintHelena: "SH",
	SaintKittsAndNevis: "KN",
	SaintLucia: "LC",
	SaintMartin: "MF",
	SaintPierreAndMiquelon: "PM",
	SaintVincentAndTheGrenadines: "VC",
	Samoa: "WS",
	SanMarino: "SM",
	SaoTomeAndPrincipe: "ST",
	SaudiArabia: "SA",
	Senegal: "SN",
	Serbia: "RS",
	Seychelles: "SC",
	SierraLeone: "SL",
	Singapore: "SG",
	SintMaarten: "SX",
	Slovakia: "SK",
	Slovenia: "SI",
	SolomonIslands: "SB",
	Somalia: "SO",
	SouthAfrica: "ZA",
	SouthGeorgiaAndTheSouthSandwichIslands: "GS",
	SouthSudan: "SS",
	Spain: "ES",
	SriLanka: "LK",
	Sudan: "SD",
	Suriname: "SR",
	SvalbardAndJanMayen: "SJ",
	Sweden: "SE",
	Switzerland: "CH",
	SyrianArabRepublic: "SY",
	Taiwan: "TW",
	Tajikistan: "TJ",
	Tanzania: "TZ",
	Thailand: "TH",
	TimorLeste: "TL",
	Togo: "TG",
	Tokelau: "TK",
	Tonga: "TO",
	TrinidadAndTobago: "TT",
	Tunisia: "TN",
	Turkey: "TR",
	Turkmenistan: "TM",
	TurksAndCaicosIslands: "TC",
	Tuvalu: "TV",
	Uganda: "UG",
	Ukraine: "UA",
	UnitedArabEmirates: "AE",
	UnitedKingdom: "GB",
	UnitedStatesMinorOutlyingIslands: "UM",
	UnitedStatesOfAmerica: "US",
	Uruguay: "UY",
	Uzbekistan: "UZ",
	Vanuatu: "VU",
	Venezuela: "VE",
	Vietnam: "VN",
	WallisAndFutuna: "WF",
	WesternSahara: "EH",
	Yemen: "YE",
	Zambia: "ZM",
	Zimbabwe: "ZW"
}, ae = [
	a.Austria,
	a.Belgium,
	a.Bulgaria,
	a.Croatia,
	a.Cyprus,
	a.CzechRepublic,
	a.Denmark,
	a.Estonia,
	a.Finland,
	a.France,
	a.Germany,
	a.Greece,
	a.Hungary,
	a.Ireland,
	a.Italy,
	a.Latvia,
	a.Lithuania,
	a.Luxembourg,
	a.Malta,
	a.Netherlands,
	a.Poland,
	a.Portugal,
	a.Romania,
	a.Slovakia,
	a.Slovenia,
	a.Spain,
	a.Sweden
], oe = Object.values(a), se = [
	a.Angola,
	a.AntiguaAndBarbuda,
	a.Aruba,
	a.Bahamas,
	a.Belize,
	a.Benin,
	a.Bermuda,
	a.BonaireSintEustatiusAndSaba,
	a.Botswana,
	a.BurkinaFaso,
	a.Burundi,
	a.Cameroon,
	a.CanaryIslands,
	a.CentralAfricanRepublic,
	a.Comoros,
	a.CongoBrazzaville,
	a.CongoKinshasa,
	a.CoteDIvoire,
	a.Curacao,
	a.Djibouti,
	a.Dominica,
	a.DutchAntilles,
	a.EquatorialGuinea,
	a.Eritrea,
	a.Fiji,
	a.Gabon,
	a.Gambia,
	a.Ghana,
	a.Grenada,
	a.Guyana,
	a.HongKong,
	a.Kiribati,
	a.KoreaPeoplesDemocraticRepublic,
	a.Macao,
	a.Malawi,
	a.Mali,
	a.Mauritania,
	a.Nauru,
	a.Qatar,
	a.Rwanda,
	a.SaintKittsAndNevis,
	a.SaoTomeAndPrincipe,
	a.Seychelles,
	a.SierraLeone,
	a.SintMaarten,
	a.Suriname,
	a.SyrianArabRepublic,
	a.TimorLeste,
	a.Togo,
	a.Tonga,
	a.Tuvalu,
	a.Uganda,
	a.UnitedArabEmirates,
	a.Vanuatu,
	a.Yemen,
	a.Zimbabwe
], ce = [
	a.Austria,
	a.Belgium,
	a.Bulgaria,
	a.Croatia,
	a.CzechRepublic,
	a.Estonia,
	a.Finland,
	a.France,
	a.Germany,
	a.Greece,
	a.Hungary,
	a.Ireland,
	a.Italy,
	a.Latvia,
	a.Lithuania,
	a.Luxembourg,
	a.Malta,
	a.Netherlands,
	a.Portugal,
	a.Romania,
	a.Slovakia,
	a.Slovenia,
	a.Spain,
	a.UnitedKingdom
], le = [
	a.Denmark,
	a.Germany,
	a.Sweden
], ue = {
	LooseLoading: 1,
	Green: 2,
	White: 3,
	CheapCargo: 4
}, o = {
	EarlyMorning: 8,
	Morning: 1,
	Standard: 2,
	Evening: 3,
	Pickup: 4,
	PickupExpress: 5,
	SameDayDelivery: 6,
	Express: 7
}, s = {
	EarlyMorning: "early_morning",
	Morning: "morning",
	Standard: "standard",
	Evening: "evening",
	Pickup: "pickup",
	PickupExpress: "pickup_express",
	SameDayDelivery: "same_day",
	Express: "express"
}, c = {
	EarlyMorning: "EARLY_MORNING_DELIVERY",
	Morning: "MORNING_DELIVERY",
	Standard: "STANDARD_DELIVERY",
	Evening: "EVENING_DELIVERY",
	Pickup: "PICKUP_DELIVERY",
	PickupExpress: "PICKUP_EXPRESS_DELIVERY",
	SameDayDelivery: "SAME_DAY_DELIVERY",
	Express: "EXPRESS_DELIVERY"
}, de = {
	[o.EarlyMorning]: s.EarlyMorning,
	[o.Morning]: s.Morning,
	[o.Standard]: s.Standard,
	[o.Evening]: s.Evening,
	[o.Pickup]: s.Pickup,
	[o.PickupExpress]: s.PickupExpress,
	[o.SameDayDelivery]: s.SameDayDelivery,
	[o.Express]: s.Express
}, fe = (e) => de[e], l = {
	[s.EarlyMorning]: o.EarlyMorning,
	[s.Morning]: o.Morning,
	[s.Standard]: o.Standard,
	[s.Evening]: o.Evening,
	[s.Pickup]: o.Pickup,
	[s.PickupExpress]: o.PickupExpress,
	[s.SameDayDelivery]: o.SameDayDelivery,
	[s.Express]: o.Express
}, pe = (e) => l[e], u = {
	[o.EarlyMorning]: c.EarlyMorning,
	[o.Morning]: c.Morning,
	[o.Standard]: c.Standard,
	[o.Evening]: c.Evening,
	[o.Pickup]: c.Pickup,
	[o.PickupExpress]: c.PickupExpress,
	[o.SameDayDelivery]: c.SameDayDelivery,
	[o.Express]: c.Express
}, me = (e) => u[e], d = { Vasco: 1 }, f = { Vasco: "vasco" }, p = { [d.Vasco]: f.Vasco }, he = (e) => p[e], ge = {
	ACCOUNT_MAX_TOTAL_INVOICE_AMOUNT_REACHED: 1001,
	BOL_SHIP_ORDER_ITEMS_FAILED: 1002,
	BOL_AUTO_IMPORT_DISABLED: 1003,
	WEBHOOK_IMPORT_FAILED: 1004,
	BOL_SHIPMENT_STATUS_UPDATE_FAILED: 1005,
	ETSY_AUTO_IMPORT_DISABLED: 1006,
	ECWID_AUTO_IMPORT_DISABLED: 1007,
	AMAZON_AUTO_IMPORT_DISABLED: 1008,
	EXACT_AUTO_IMPORT_DISABLED: 1009,
	EXACT_DE_AUTO_IMPORT_DISABLED: 1010,
	WIX_AUTO_IMPORT_DISABLED: 1011,
	BLACKLISTED: 1012
}, _e = {
	Apart: "apart",
	Nested: "nested",
	None: "none"
}, ve = {
	Requested: "requested",
	Active: "active",
	Cancelled: "cancelled",
	Inactive: "inactive"
}, ye = {
	New: 1,
	Active: 2,
	Inactive: 3,
	Suspended: 4,
	Unverified: 8,
	Anonymized: 9
}, be = {
	Mr: "mr",
	Ms: "ms"
}, xe = {
	Recipient: "recipient",
	Collect: "collect"
}, Se = {
	Brackets: "brackets",
	Shipments: "shipments",
	ShipmentsWeekly: "shipments-weekly",
	ShipmentsT2: "shipments-t2",
	ShipmentsT3: "shipments-t3",
	ShipmentsT4: "shipments-t4",
	Returns: "returns",
	ReturnsWeekly: "returns-weekly",
	ReturnsT2: "returns-t2",
	ReturnsT3: "returns-t3",
	ReturnsT4: "returns-t4",
	Webshops: "webshops",
	WebshopsWeekly: "webshops-weekly",
	WebshopsT2: "webshops-t2",
	WebshopsT3: "webshops-t3",
	WebshopsT4: "webshops-t4",
	TransitTime: "transit-time",
	TransitTimeT2: "transit-time-t2",
	TransitTimeT3: "transit-time-t3",
	TransitTimeT4: "transit-time-t4",
	Surcharges: "surcharges",
	SurchargesT2: "surcharges-t2",
	SurchargesT3: "surcharges-t3",
	SurchargesT4: "surcharges-t4",
	Cases: "cases",
	CasesT2: "cases-t2",
	CasesT3: "cases-t3",
	CasesT4: "cases-t4",
	FinanceT2: "finance-t2",
	FinanceT3: "finance-t3",
	FinanceT4: "finance-t4",
	ShortcomingT2: "shortcoming-t2",
	ShortcomingT3: "shortcoming-t3",
	ShortcomingT4: "shortcoming-t4"
}, Ce = {
	Shipments: "shipments",
	Returns: "returns",
	Webshops: "webshops",
	TransitTime: "transit-time",
	Surcharges: "surcharges",
	Cases: "cases",
	Finance: "finance",
	Shortcoming: "shortcoming"
}, we = {
	Active: "active",
	Pending: "pending",
	Inactive: "inactive"
}, Te = {
	Open: "open",
	Pending: "pending",
	Succes: "succes",
	Failure: "failure",
	Expired: "expired",
	Cancelled: "cancelled"
}, Ee = {
	Create: "create",
	Update: "update",
	Revoke: "revoke"
}, De = {
	Discount: "Discount",
	Option: "Option",
	Refund: "Refund",
	Shipment: "Shipment",
	Surcharge: "Surcharge"
}, Oe = {
	Prepaid: 1,
	Invoice: 2,
	DirectDebit: 3,
	PostPaymentDirectDebitPending: 4,
	PrePaymentDirectDebitPending: 5
}, ke = {
	Active: "active",
	Available: "available",
	Unavailable: "unavailable",
	Pending: "pending"
}, Ae = {
	Monthly: "monthly",
	Weekly: "weekly"
}, je = {
	Emandate: "e_mandate",
	EmailForm: "email_form"
}, Me = {
	ReverseCharge: "reverse_charge",
	General: "general",
	Zero: "zero"
}, Ne = 210, Pe = {
	Fulfilment: "Fulfilment NL PostNL",
	ParcelEu: "MyParcel Pakket EU PostNL",
	ParcelNl: "MyParcel Pakket NL PostNL",
	PackageSmallNl: "MyParcel Klein Pakket NL PostNL",
	PackageSmallBe: "MyParcel Klein Pakket BE PostNL",
	ParcelErs: "MyParcel Pakket ERS PostNL",
	MailboxParcel: "MyParcel Brievenbuspakje PostNL",
	SmpParcelEu: "België Pakket EU PostNL",
	SmpParceNL: "België Pakket NL PostNL",
	SmpParcelBe: "België Pakket BE PostNL",
	FlsParcelEu: "Flespakket Pakket EU PostNL",
	FlsParcelNl: "Flespakket Pakket NL PostNL",
	FlsParcelErs: "Flespakket Pakket ERS PostNL",
	FlsMailboxParcel: "Flespakket Brievenbuspakje PostNL"
}, Fe = {
	ParcelNl: "MyParcel Pakket NL DHL For You",
	ParcelBe: "MyParcel Pakket BE DHL For You",
	MailboxParcelNl: "MyParcel Brievenbuspakje NL DHL For You",
	MailboxParcelBe: "MyParcel Brievenbuspakje BE DHL For You",
	ParcelSameDayNl: "MyParcel Pakket NL DHL For You vandaag",
	MailboxParcelSameDayNl: "MyParcel Brievenbuspakje NL DHL For You vandaag",
	EnvelopeNl: "MyParcel Envelop NL DHL For You"
}, Ie = {
	ParcelNl: "MyParcel Pakket NL DHL Europlus",
	ParcelEu: "MyParcel Pakket EU DHL Europlus"
}, Le = { ParcelEu: "MyParcel Pakket EU DHL Parcel Connect" }, Re = {
	ParcelNl: "MyParcel Pakket NL DPD",
	ParcelEu: "MyParcel Pakket EU DPD",
	MailboxParcelNL: "MyParcel Brievenbuspakje NL DPD",
	SmpParcelEu: "België Pakket EU DPD",
	SmpParcelRow: "België Pakket ROW DPD",
	SmpParcelBe: "België Pakket BE DPD"
}, ze = {
	ParcelBe: "België Pakket BE Bpost",
	ParcelEu: "België Pakket EU Bpost"
}, Be = {
	ParcelNl: "MyParcel Pakket NL UPS Standaard",
	ParcelEu: "MyParcel Pakket EU UPS Standaard",
	ParcelNlExpressSaver: "MyParcel Pakket NL UPS Express Saver",
	ParcelEuExpressSaver: "MyParcel Pakket EU UPS Express Saver"
}, Ve = {
	Subscription: "MyParcel Abonnement zending",
	SmpSubscription: "België Abonnement zending"
}, He = {
	Main: "main",
	Custom: "custom"
}, Ue = {
	DemoReady: "demoReady",
	PortalLoaded: "portalLoaded",
	InitDemo: "initDemo",
	UpdateBranding: "updateBranding",
	UpdateFields: "updateFields",
	UpdateReturnSettings: "updateReturnSettings",
	Navigate: "navigate",
	MobileDisplayMode: "mobileDisplayMode",
	Locale: "locale"
}, We = {
	Completed: "completed",
	Cancelled: "cancelled",
	Initialized: "initialized",
	Expired: "expired",
	InvalidHash: "invalid_hash"
}, Ge = {
	Registered: "registered",
	HandedToCarrier: "handed_to_carrier",
	Sorting: "sorting",
	Distribution: "distribution",
	Delivered: "delivered"
}, Ke = {
	Registered: 0,
	HandedToCarrier: 3,
	Sorting: 4,
	Distribution: 5,
	Delivered: 7
}, qe = {
	None: "none",
	InstagramPost: "instagram_post",
	TwitterTimeline: "twitter_timeline"
}, Je = {
	Instagram: "instagram",
	Twitter: "twitter",
	Linkedin: "linkedin",
	Facebook: "facebook",
	Youtube: "youtube",
	Tiktok: "tiktok"
}, Ye = {
	Euro: "EUR",
	Usd: "USD"
}, m = {
	Sunday: 0,
	Monday: 1,
	Tuesday: 2,
	Wednesday: 3,
	Thursday: 4,
	Friday: 5,
	Saturday: 6
}, h = {
	Sunday: "sunday",
	Monday: "monday",
	Tuesday: "tuesday",
	Wednesday: "wednesday",
	Thursday: "thursday",
	Friday: "friday",
	Saturday: "saturday"
}, Xe = {
	[h.Sunday]: m.Sunday,
	[h.Monday]: m.Monday,
	[h.Tuesday]: m.Tuesday,
	[h.Wednesday]: m.Wednesday,
	[h.Thursday]: m.Thursday,
	[h.Friday]: m.Friday,
	[h.Saturday]: m.Saturday
}, Ze = {
	[m.Sunday]: h.Sunday,
	[m.Monday]: h.Monday,
	[m.Tuesday]: h.Tuesday,
	[m.Wednesday]: h.Wednesday,
	[m.Thursday]: h.Thursday,
	[m.Friday]: h.Friday,
	[m.Saturday]: h.Saturday
}, Qe = (e) => Ze[e], $e = (e) => Xe[e], et = {
	Affiliate: 1,
	Return: 2,
	Tracktrace: 3,
	ShipmentLabel: 4,
	TracktraceReturn: 5
}, tt = {
	CSV: "text/csv",
	TXT: "text/plain"
}, g = {
	Bytes: "B",
	Kilobytes: "KB",
	Megabytes: "MB",
	Gigabytes: "GB",
	Terabytes: "TB"
}, nt = [
	g.Bytes,
	g.Kilobytes,
	g.Megabytes,
	g.Gigabytes,
	g.Terabytes
], rt = {
	Automatic: "automatic",
	Manual: "manual"
}, it = {
	Invalid: 3415,
	Dimensions: 3440,
	Filetype: 3441,
	Width: 3442,
	Size: 3462
}, at = {
	Shipments: "shipments",
	ShipmentsWeekly: "shipments-weekly",
	ShipmentsT2: "shipments-t2",
	ShipmentsT3: "shipments-t3",
	Returns: "returns",
	ReturnsWeekly: "returns-weekly",
	ReturnsT2: "returns-t2",
	ReturnsT3: "returns-t3",
	Webshops: "webshops",
	WebshopsWeekly: "webshops-weekly",
	WebshopsT2: "webshops-t2",
	WebshopsT3: "webshops-t3",
	TransitTime: "transit-time",
	TransitTimeT2: "transit-time-t2",
	TransitTimeT3: "transit-time-t3",
	Surcharges: "surcharges",
	SurchargesT2: "surcharges-t2",
	SurchargesT3: "surcharges-t3",
	Cases: "cases",
	CasesT2: "cases-t2",
	CasesT3: "cases-t3",
	FinanceT2: "finance-t2",
	FinanceT3: "finance-t3",
	ShortcomingT2: "shortcoming-t2",
	ShortcomingT3: "shortcoming-t3"
}, ot = {
	Shipments: "shipments",
	Returns: "returns",
	Webshops: "webshops",
	TransitTime: "transit-time",
	Surcharges: "surcharges",
	Cases: "cases",
	Finance: "finance",
	Shortcoming: "shortcoming"
}, _ = {
	Bol: 1,
	Exact: 2,
	Amazon: 6,
	Wix: 8,
	ExactDe: 10,
	Etsy: 11
}, v = {
	Bol: "bol_dot_com",
	Wix: "wix",
	Exact: "exact",
	ExactDe: "exact_de",
	Amazon: "amazon",
	Etsy: "etsy"
}, y = {
	[_.Bol]: v.Bol,
	[_.Exact]: v.Exact,
	[_.Amazon]: v.Amazon,
	[_.Wix]: v.Wix,
	[_.ExactDe]: v.ExactDe,
	[_.Etsy]: v.Etsy
}, st = (e) => y[e], b = {
	[v.Bol]: _.Bol,
	[v.Exact]: _.Exact,
	[v.Amazon]: _.Amazon,
	[v.Wix]: _.Wix,
	[v.ExactDe]: _.ExactDe,
	[v.Etsy]: _.Etsy
}, ct = (e) => b[e], lt = {
	Pending: 1,
	Active: 2,
	Blocked: 3
}, ut = {
	Reminder1: "billing_invoice_first_reminder",
	Reminder2: "billing_invoice_second_reminder",
	Dun: "billing_invoice_due_dun"
}, x = {
	Unpaid: 1,
	Due: 101,
	DuePrepayment: 102,
	Reminder1: 106,
	Reminder2: 111,
	Dun: 116,
	Collection: 121,
	Instalments: 126,
	PaymentArrangement: 127,
	Dispute: 128,
	LegalProcedure: 129,
	Insolvency: 130,
	WriteOff: 131,
	Pending: 301,
	Cancelled: 401,
	Paid: 501,
	PaidOnline: 506,
	PaidAutomatic: 511,
	PaidCredit: 597,
	PaidZeroItems: 598,
	InvoiceWith0InvoiceItemsPaidZeroBalance: 599
}, S = {
	Unpaid: "Unpaid",
	Due: "Due",
	DuePrepayment: "DuePrepayment",
	Reminder1: "Reminder1",
	Reminder2: "Reminder2",
	Dun: "Dun",
	Collection: "Collection",
	Instalments: "Instalments",
	PaymentArrangement: "PaymentArrangement",
	Dispute: "Dispute",
	LegalProcedure: "LegalProcedure",
	Insolvency: "Insolvency",
	WriteOff: "WriteOff",
	Pending: "Pending",
	Cancelled: "Cancelled",
	Paid: "Paid",
	PaidOnline: "PaidOnline",
	PaidAutomatic: "PaidAutomatic",
	PaidCredit: "PaidCredit",
	PaidZeroItems: "PaidZeroItems",
	PaidZeroBalance: "PaidZeroBalance"
}, dt = {
	[x.Unpaid]: S.Unpaid,
	[x.Due]: S.Due,
	[x.DuePrepayment]: S.DuePrepayment,
	[x.Reminder1]: S.Reminder1,
	[x.Reminder2]: S.Reminder2,
	[x.Dun]: S.Dun,
	[x.Collection]: S.Collection,
	[x.Instalments]: S.Instalments,
	[x.PaymentArrangement]: S.PaymentArrangement,
	[x.Dispute]: S.Dispute,
	[x.LegalProcedure]: S.LegalProcedure,
	[x.Insolvency]: S.Insolvency,
	[x.WriteOff]: S.WriteOff,
	[x.Pending]: S.Pending,
	[x.Cancelled]: S.Cancelled,
	[x.Paid]: S.Paid,
	[x.PaidOnline]: S.PaidOnline,
	[x.PaidAutomatic]: S.PaidAutomatic,
	[x.PaidCredit]: S.PaidCredit,
	[x.PaidZeroItems]: S.PaidZeroItems,
	[x.InvoiceWith0InvoiceItemsPaidZeroBalance]: S.PaidZeroBalance
}, ft = [
	x.Due,
	x.Reminder1,
	x.Reminder2,
	x.Dun,
	x.Collection,
	x.Instalments,
	x.PaymentArrangement,
	x.Dispute
], pt = [
	x.Paid,
	x.PaidOnline,
	x.PaidAutomatic,
	x.PaidCredit,
	x.PaidZeroItems
], mt = {
	Open: "open",
	Paid: "paid"
}, ht = {
	Customer: 1,
	Consumer: 2,
	ConsumerERS: 3
}, gt = {
	Info: "info",
	Success: "success",
	Warning: "warning",
	Error: "alert"
}, _t = {
	Full: "full",
	Half: "half"
}, vt = { Toaster: "toaster" }, yt = {
	Asc: "ASC",
	Desc: "DESC"
}, bt = {
	MyParcel: "myparcel",
	User: "user"
}, xt = {
	Gram: "gram",
	Kilogram: "kilogram"
}, C = {
	Gram: "g",
	Kilogram: "kg"
}, St = {
	[C.Gram]: 1,
	[C.Kilogram]: 1e3
}, Ct = {
	Millimeter: "millimeter",
	Centimeter: "centimeter",
	Meter: "meter"
}, w = {
	Millimeter: "mm",
	Centimeter: "cm",
	Meter: "m"
}, wt = {
	[w.Millimeter]: .1,
	[w.Centimeter]: 1,
	[w.Meter]: 100
}, Tt = {
	Dm3Refund1: "Dm3 Refund 0-55",
	Dm3Refund2: "Dm3 Refund 55-105",
	Dm3Refund3: "Dm3 Refund 105-205",
	Dm3Refund4: "Dm3 Refund 205",
	Dm3Surcharge1: "Dm3 Surcharge 0-55",
	Dm3Surcharge2: "Dm3 Surcharge 55-105",
	Dm3Surcharge3: "Dm3 Surcharge 105-205",
	Dm3Surcharge4: "Dm3 Surcharge 205",
	ErsAt: "ERS Shipment AT",
	ErsBe: "ERS Shipment BE",
	ErsBg: "ERS Shipment BG",
	ErsCz: "ERS Shipment CZ",
	ErsDe: "ERS Shipment DE",
	ErsEe: "ERS Shipment EE",
	ErsEs: "ERS Shipment ES",
	ErsFi: "ERS Shipment FI",
	ErsFr: "ERS Shipment FR",
	ErsGb: "ERS Shipment GB",
	ErsGr: "ERS Shipment GR",
	ErsHr: "ERS Shipment HR",
	ErsHu: "ERS Shipment HU",
	ErsIe: "ERS Shipment IE",
	ErsIt: "ERS Shipment IT",
	ErsLt: "ERS Shipment LT",
	ErsLu: "ERS Shipment LU",
	ErsLv: "ERS Shipment LV",
	ErsMt: "ERS Shipment MT",
	ErsPt: "ERS Shipment PT",
	ErsRo: "ERS Shipment RO",
	ErsSi: "ERS Shipment SI",
	ErsSk: "ERS Shipment SK",
	InsurancePostNl: "Insurance PostNL",
	InsurancePostNlEur100: "Insurance PostNL EUR 100",
	InsurancePostNlEur250: "Insurance PostNL EUR 250",
	InsurancePostNlEur50ToEuRow: "Insurance PostNL EUR 50 to EU & ROW",
	InsurancePostNlEur500PlusNlToBe: "Insurance PostNL EUR 500 Plus NL to BE",
	InsurancePostNlEur500ToEuRow: "Insurance PostNL EUR 500 to EU & ROW",
	InsurancePostNlEur500: "Insurance PostNL EUR 500",
	InsurancePostNlNlToBeEur500: "Insurance PostNL NL to BE EUR 500",
	LargeFormatNl: "Large Format NL",
	LargeFormatEu: "Large Format EU",
	LargeFormatBe: "Large Format BE",
	LargeFormatDe: "Large Format DE",
	LargeFormatFr: "Large Format FR",
	LargeFormatEs: "Large Format ES",
	LargeFormatRefundNl: "Large Format Refund NL",
	LargeFormatRefundEu: "Large Format Refund EU",
	LargeFormatRefundBe: "Large Format Refund BE",
	LargeFormatRefundDe: "Large Format Refund DE",
	LargeFormatRefundFr: "Large Format Refund FR",
	LargeFormatRefundEs: "Large Format Refund ES",
	LargeFormatSurchargeNl: "Large Format Surcharge NL",
	LargeFormatSurchargeEu: "Large Format Surcharge EU",
	LargeFormatSurchargeBe: "Large Format Surcharge BE",
	LargeFormatSurchargeDe: "Large Format Surcharge DE",
	LargeFormatSurchargeFr: "Large Format Surcharge FR",
	LargeFormatSurchargeEs: "Large Format Surcharge ES",
	ShipmentAu: "Shipment AU",
	ShipmentBe: "Shipment BE",
	ShipmentBr: "Shipment BR",
	ShipmentCa: "Shipment CA",
	ShipmentCh: "Shipment CH",
	ShipmentCn: "Shipment CN",
	ShipmentEu3: "Shipment EU3",
	ShipmentGb: "Shipment GB",
	ShipmentHk: "Shipment HK",
	ShipmentJp: "Shipment JP",
	ShipmentNl: "Shipment NL",
	ShipmentNo: "Shipment NO",
	ShipmentNz: "Shipment NZ",
	ShipmentRow: "Shipment ROW",
	ShipmentUs: "Shipment US",
	ShipmentZa: "Shipment ZA",
	ShipmentEu1And2: "Shipment EU 1 & 2",
	ShipmentEs: "Shipment ES",
	ShipmentDe: "Shipment DE",
	ShipmentFr: "Shipment FR",
	WeightAu: "Weight AU",
	WeightBr: "Weight BR",
	WeightCa: "Weight CA",
	WeightCh: "Weight CH",
	WeightCn: "Weight CN",
	WeightEu3: "Weight EU3",
	WeightGb: "Weight GB",
	WeightHk: "Weight HK",
	WeightJp: "Weight JP",
	WeightNo: "Weight NO",
	WeightNz: "Weight NZ",
	WeightRow: "Weight ROW",
	WeightUs: "Weight US",
	WeightZa: "Weight ZA",
	AgeCheck: "age_check",
	Signature: "Signature",
	OnlyRecipient: "Only recipient",
	OnlyRecipientSignature: "Only recipient & Signature",
	PrinterlessReturn: "Printerless return",
	BundleMaxLabelFee: "Bundle Max label fee",
	BundleMaxLabelDiscount: "Bundle Max label discount",
	BundleMaxShipmentDiscount: "Bundle Max shipment discount",
	BundlePlusLabelDiscount: "Bundle Plus label discount",
	BundlePlusLabelFee: "Bundle Plus label fee",
	BundlePlusShipmentDiscount: "Bundle Plus shipment discount",
	BundlePremiumLabelDiscount: "Bundle Premium label discount",
	BundlePremiumLabelFee: "Bundle Premium label fee",
	BundlePremiumShipmentDiscount: "Bundle Premium shipment discount",
	BundleStartLabelDiscount: "Bundle Start label discount",
	BundleStartLabelFee: "Bundle Start label fee",
	BundleStartShipmentDiscount: "Bundle Start shipment discount",
	Brievenbuspakje: "Brievenbuspakje",
	BrievenbuspakjePeakSurcharge: "Brievenbuspakje Peak Surcharge",
	BrievenbuspakjeToeslag: "Brievenbuspakje Toeslag",
	DigitalePostzegel: "Digitale postzegel",
	SmallParcelEU: "Small Parcel EU",
	SmallParcelROW: "Small Parcel ROW",
	MailboxPackageEU: "Mailbox Package EU",
	MailboxPackageROW: "Mailbox Package ROW",
	EnergySurcharge: "Energy surcharge",
	EveningDelivery: "Evening delivery",
	IncorrectConfirmation: "Incorrect Confirmation",
	KortingOphaallocatie: "Korting ophaallocatie",
	ManualProcessing: "Manual Processing",
	ManualProcessingNoContract: "Manual Processing (no contract)",
	ManualProcessingNoContractRefund: "Manual Processing (no contract) refund",
	ManualProcessingRefund: "Manual Processing refund",
	MaximumDimensionsExceeded: "Maximum Dimensions Exceeded",
	MorningDelivery: "Morning delivery",
	MulticolloDiscount: "Multicollo discount",
	NotificationSurcharge: "Notification Surcharge",
	PeakSurcharge: "Peak Surcharge",
	PromotionalDiscount: "Promotional discount",
	UndeliverableEuShipment: "Undeliverable EU Shipment",
	UndeliverableRowShipment: "Undeliverable ROW Shipment",
	WeightSurcharge: "Weight Surcharge",
	WeightSurchargeRefund: "Weight Surcharge refund",
	DhlSurcharge10To24Dm3To10Kg: "DHL surcharge 10-24 dm3 / to 10 kg",
	DhlSurcharge24To60Dm3To15Kg: "DHL surcharge 24-60 dm3 / to 15 kg",
	DhlSurcharge60To240Dm3To23Kg: "DHL surcharge 60-240 dm3 / to 23 kg",
	DhlSurcharge240To432Dm3To315Kg: "DHL surcharge 240-432 dm3 / to 31.5 kg",
	DhlForYouPakketNlS: "DHL For You Pakket NL - S",
	DhlForYouPakketNlM: "DHL For You Pakket NL - M",
	DhlForYouPakketNlL: "DHL For You Pakket NL - L",
	DhlForYouPakketNlXl: "DHL For You Pakket NL - XL",
	DhlForYouPakketNlXxl: "DHL For You Pakket NL - XXL",
	DhlForYouPakketBeS: "DHL For You Pakket BE - S",
	DhlForYouPakketBeM: "DHL For You Pakket BE - M",
	DhlForYouPakketBeL: "DHL For You Pakket BE - L",
	DhlForYouPakketBeXl: "DHL For You Pakket BE - XL",
	DhlForYouPakketBeXxl: "DHL For You Pakket BE - XXL",
	DhlEveningDelivery: "DHL Evening delivery",
	DhlSaturdayDelivery: "DHL Saturday delivery",
	DhlSignatureOnDelivery: "DHL Signature on delivery",
	DhlNotAtNeighbours: "DHL Not at neighbours",
	DhlAgeCheck: "DHL Age check",
	DhlExtraAssurance: "DHL Extra assurance",
	DhlForYouLetterboxParcelNetherlands: "DHL For You Letterbox Parcel Netherlands",
	DhlTodayParcel: "DHL Today (parcel)",
	DhlTodayLetterbox: "DHL Today (letterbox)",
	ImplicitDiscount: "Implicit discount",
	DhlForYouLetterboxParcelBelgium: "DHL For You Letterbox Parcel Belgium",
	DhlSamedayParcel: "DHL Sameday Parcel",
	DhlSamedayLetterboxParcel: "DHL Sameday Letterbox parcel",
	DhlFuelSurcharge: "DHL Fuel surcharge",
	DhlTollSurcharge: "DHL Toll surcharge",
	DhlGoGreenSurcharge: "DHL GoGreen surcharge",
	DhlParcelConnectParcel: "DHL Parcel Connect parcel",
	DhlExtraLarge: "DHL Extra large",
	DhlHeavyParcel: "DHL Heavy parcel",
	DhlEuroplusParcel: "DHL Europlus parcel",
	DhlEuroplusParcelNl: "DHL Europlus parcel NL",
	UpsStandardPackage: "UPS Standard Package",
	UpsExpressSaverPackage: "UPS Express Saver Package",
	UpsStandardPackageShipmentPickup: "UPS Standard Package + Shipment pickup",
	UpsExpressSaverPackageShipmentPickup: "UPS Express Saver Package + Shipment pickup",
	UpsProfitMargin: "UPS Profit margin",
	StandardPackageBe: "Standard package BE",
	StandardPackageFromPickupLocationBe: "Standard package from pickup location BE",
	ShipmentEuBe: "Shipment EU BE",
	RowBe: "ROW BE",
	StandardMailboxBe: "Standard Mailbox BE",
	HomeDeliveryBe: "Home delivery BE",
	HomeDeliveryEu: "Home delivery EU",
	PickupBe: "Pickup BE",
	PickupEu: "Pickup EU",
	PickupReturnBe: "Pickup Return BE",
	PickupReturnEu: "Pickup Return EU",
	HomeDeliveryRow: "Home delivery ROW"
}, T = {
	Eu: "EU",
	HomeCountry: "Home Country",
	Row: "ROW",
	Cd: "CD",
	World: "WERELD"
}, Et = {
	Bol: "BOL",
	Lightspeed: "LIGHTSPEED",
	Magento: "MAGENTO",
	Presta: "PRESTA",
	Shopify: "SHOPIFY",
	Woocommerce: "WOOCOMMERCE"
}, Dt = {
	PendingConcept: 1,
	PendingRegistered: 2,
	EnRouteHandedToCarrier: 3,
	EnRouteSorting: 4,
	EnRouteDistribution: 5,
	EnRouteCustoms: 6,
	DeliveredAtRecipient: 7,
	DeliveredReadyForPickup: 8,
	DeliveredPackagePickedUp: 9,
	DeliveredReturnShipmentReadyForPickup: 10,
	DeliveredReturnShipmentPackagePickedUp: 11,
	PrintedLetter: 12,
	InactiveCredited: 13,
	PrintedDigitalStamp: 14,
	Expired: 16,
	Cancelled: 17,
	InactiveConcept: 30,
	InactiveRegistered: 31,
	InactiveEnRouteHandedToCarrier: 32,
	InactiveEnRouteSorting: 33,
	InactiveEnRouteDistribution: 34,
	InactiveEnRouteCustoms: 35,
	InactiveDeliveredAtRecipient: 36,
	InactiveDeliveredReadyForPickup: 37,
	InactiveDeliveredPackagePickedUp: 38
}, Ot = {
	Standard: 1,
	Return: 2,
	MultiColli: 3,
	LabelPackage: 4,
	ReturnErs: 5,
	UpsExpress: 7
}, kt = {
	Pending: "pending",
	Unpaid: "unpaid",
	Paid: "paid"
}, At = {
	AgeCheck: "age_check",
	Collect: "collect",
	Contribution: "contribution",
	CooledDelivery: "cooled_delivery",
	DeliveryDate: "delivery_date",
	DeliveryType: "delivery_type",
	DropOffAtPostalPoint: "drop_off_at_postal_point",
	ExtraAssurance: "extra_assurance",
	FreshFood: "fresh_food",
	Frozen: "frozen",
	HideSender: "hide_sender",
	Insurance: "insurance",
	LabelDescription: "label_description",
	LargeFormat: "large_format",
	OnlyRecipient: "only_recipient",
	PackageType: "package_type",
	PrinterlessReturn: "printerless_return",
	PriorityDelivery: "priority_delivery",
	ReceiptCode: "receipt_code",
	Return: "return",
	SameDayDelivery: "same_day_delivery",
	SaturdayDelivery: "saturday_delivery",
	Signature: "signature",
	Tracked: "tracked"
}, jt = {
	CommercialGoods: 1,
	CommercialSamples: 2,
	Documents: 3,
	Gifts: 4,
	ReturnShipment: 5
}, Mt = {
	Standard: "standard",
	Return: "return"
}, E = {
	Light: "light",
	Start: "start",
	Plus: "plus",
	Premium: "premium",
	Max: "max"
}, D = {
	Light: 0,
	Start: 1,
	Plus: 2,
	Premium: 3,
	Max: 4
}, Nt = {
	Zero: 0,
	One: 1,
	Two: 2,
	Three: 3,
	Four: 4,
	Five: 5
}, Pt = {
	[D.Light]: E.Light,
	[D.Start]: E.Start,
	[D.Plus]: E.Plus,
	[D.Premium]: E.Premium,
	[D.Max]: E.Max
}, Ft = {
	[E.Light]: D.Light,
	[E.Start]: D.Start,
	[E.Plus]: D.Plus,
	[E.Premium]: D.Premium,
	[E.Max]: D.Max
}, It = (e) => Pt[e], Lt = (e) => Ft[e], O = {
	Start: 4800,
	Plus: 4801,
	Premium: 4802,
	Max: 4803
}, k = {
	Start: E.Start,
	Plus: E.Plus,
	Premium: E.Premium,
	Max: E.Max
}, Rt = {
	[O.Start]: k.Start,
	[O.Plus]: k.Plus,
	[O.Premium]: k.Premium,
	[O.Max]: k.Max
}, A = {
	[k.Start]: O.Start,
	[k.Plus]: O.Plus,
	[k.Premium]: O.Premium,
	[k.Max]: O.Max
}, zt = (e) => Rt[e], Bt = (e) => A[e], Vt = {
	AllowCustomContracts: "allow_custom_contracts",
	AllowBolDotComVvbShipments: "allow_bol_dot_com_vvb_shipments",
	AllowAutoOrderImport: "allow_auto_order_import",
	AllowOrderNotes: "allow_order_notes",
	AllowUnlimitedShipmentsPerOrderLine: "allow_unlimited_shipments_per_order_line",
	AllowOrderInvoice: "allow_order_invoice",
	AllowOrderPicklist: "allow_order_picklist",
	AllowNestedShipmentLabelOnPackingSlip: "allow_nested_shipment_label_on_packing_slip",
	AllowShopLogoOnPackingSlip: "allow_shop_logo_on_packing_slip",
	ExtendedShippingRules: "extended_shipping_rules",
	UnlimitedShippingRules: "unlimited_shipping_rules",
	AllowTier1Analytics: "allow_tier1_analytics",
	AllowTier2Analytics: "allow_tier2_analytics",
	AllowTier3Analytics: "allow_tier3_analytics",
	ShipmentDiscount: "shipment_discount"
}, j = {
	Start: 4700,
	Plus: 4701,
	Premium: 4702,
	Max: 4703
}, M = {
	Start: E.Start,
	Plus: E.Plus,
	Premium: E.Premium,
	Max: E.Max
}, N = {
	[j.Start]: M.Start,
	[j.Plus]: M.Plus,
	[j.Premium]: M.Premium,
	[j.Max]: M.Max
}, P = {
	[M.Start]: j.Start,
	[M.Plus]: j.Plus,
	[M.Premium]: j.Premium,
	[M.Max]: j.Max
}, Ht = (e) => N[e], Ut = (e) => P[e], F = {
	Light: 4610,
	Start: 4611,
	Plus: 4612,
	Premium: 4613,
	Max: 4614
}, I = {
	Light: E.Light,
	Start: E.Start,
	Plus: E.Plus,
	Premium: E.Premium,
	Max: E.Max
}, L = {
	[F.Light]: I.Light,
	[F.Start]: I.Start,
	[F.Plus]: I.Plus,
	[F.Premium]: I.Premium,
	[F.Max]: I.Max
}, R = {
	[I.Light]: F.Light,
	[I.Start]: F.Start,
	[I.Plus]: F.Plus,
	[I.Premium]: F.Premium,
	[I.Max]: F.Max
}, Wt = (e) => L[e], Gt = (e) => R[e], z = {
	Start: 4615,
	Plus: 4616,
	Premium: 4617,
	Max: 4618
}, B = {
	Start: E.Start,
	Plus: E.Plus,
	Premium: E.Premium,
	Max: E.Max
}, V = {
	[z.Start]: B.Start,
	[z.Plus]: B.Plus,
	[z.Premium]: B.Premium,
	[z.Max]: B.Max
}, H = {
	[B.Start]: z.Start,
	[B.Plus]: z.Plus,
	[B.Premium]: z.Premium,
	[B.Max]: z.Max
}, Kt = (e) => V[e], qt = (e) => H[e], Jt = {
	MyContract: "my_contracts",
	MyAnalytics: "my_analytics",
	MyOrders: "my_orders",
	MyScanAndPrint: "my_scan_and_print",
	MyReturns: "my_returns",
	Bundle: "bundle"
}, Yt = {
	Active: "active",
	Ended: "ended",
	Pending: "pending",
	StartingSoon: "starting_soon",
	EndingSoon: "ending_soon",
	TrialActive: "trial_active",
	TrialEnded: "trial_ended"
}, Xt = {
	Open: "open",
	Closed: "closed"
}, Zt = {
	Damage: "damage",
	InvoiceChangeDetails: "invoice_change_details",
	InvoiceOtherQuestion: "invoice_other_question",
	MissingContent: "missing_content",
	MyReturnsCancellation: "my_returns_cancellation",
	MyReturnsRequest: "my_returns_request",
	NoValueChosen: "no_value_chosen",
	NotDelivered: "not_delivered",
	NotReceivedRecipient: "not_received_recipient",
	NotReceivedRecipientBbp: "not_received_recipient_bbp",
	OtherSystemQuestion: "other_system_question",
	Packaging: "packaging",
	PalletShipmentQuestion: "pallet_shipment_question",
	PluginHelpNeeded: "plugin_help_needed",
	PluginQuestion: "plugin_question",
	Products: "products",
	Rates: "rates",
	RecipientIncorrect: "recipient_incorrect",
	Return: "return",
	ShipmentExportHelpNeeded: "shipment_export_help_needed",
	ShipmentOtherQuestion: "shipment_other_question",
	WebshopOrders: "webshop_orders"
}, Qt = {
	MyShipments: 1,
	System: 2,
	ProductsAndPrices: 3,
	MyInvoice: 4,
	Different: 5,
	MyCollectTrip: 6,
	Fulfilment: 7,
	MyReturns: 8
}, $t = {
	NL: "nl",
	EN: "en",
	FR: "fr",
	IT: "it",
	ES: "es",
	DE: "de"
}, en = {
	Text: "Text",
	ChangeStatus: "ChangeStatus",
	EmailMessage: "EmailMessage"
}, tn = {
	SHIPMENT_FORM: 1,
	DASHBOARD: 2,
	GLOBAL_MESSAGE: 3,
	COLLECTION_TRIP_MESSAGE: 4,
	CASES_OVERVIEW: 5,
	CONTACT: 6
}, nn = {
	ALERT: "alert",
	WARNING: "warning",
	SUCCESS: "success",
	INFO: "info",
	DEFAULT: "info"
}, rn = {
	Ok: 1,
	Processing: 2,
	Failed: 3,
	Cancelled: 4,
	Expired: 5,
	Declined: 6,
	PartialRefunded: 7,
	ChargedBack: 8,
	Refunded: 9,
	Reserved: 10,
	Uncleared: 11,
	InvalidHash: 12
}, an = {
	BankTransfer: 1,
	Ideal: 2,
	DirectDebit: 4,
	SystemCorrection: 5,
	CollectionAgency: 6,
	OtherManualPayment: 7
}, on = {
	Owner: "customer_main",
	Main: "customer_admin",
	Regular: "customer_sub",
	Warehouse: "customer_warehouse",
	Marketing: "customer_marketing",
	CustomerService: "customer_service",
	Financial: "customer_financial",
	FunctionalManager: "customer_functional_manager",
	Sales: "sales",
	ItSupport: "it_support",
	Finance: "finance",
	CsAdvanced: "cs_advanced",
	Cs: "cs",
	SuperAdmin: "super_admin"
}, sn = {
	ShipmentLabelCreated: "shipment_label_created",
	ShipmentStatusChange: "shipment_status_change"
}, U = {
	MyParcel: 1,
	Flespakket: 2,
	SendMyParcel: 3,
	DeliverDutch: 4,
	PostNlPlugin: 5,
	MyParcelIt: 6
}, W = {
	MyParcel: "myparcel",
	Flespakket: "flespakket",
	SendMyParcel: "belgie",
	DeliverDutch: "deliver-dutch",
	PostNlPlugin: "postnl-plugin",
	MyParcelIt: "italie"
}, G = {
	Default: "default",
	MyParcelNl: "myparcel-nederland",
	MyParcelBe: "myparcel-belgie",
	MyParcelIt: "myparcel-italie",
	DeliverDutch: "deliver-dutch",
	PostNlPlugin: "postnl-plugin"
}, K = {
	[U.MyParcel]: W.MyParcel,
	[U.Flespakket]: W.Flespakket,
	[U.SendMyParcel]: W.SendMyParcel,
	[U.MyParcelIt]: W.MyParcelIt,
	[U.DeliverDutch]: W.DeliverDutch,
	[U.PostNlPlugin]: W.PostNlPlugin
}, cn = (e) => K[e], ln = {
	[U.MyParcel]: G.MyParcelNl,
	[U.Flespakket]: G.MyParcelNl,
	[U.SendMyParcel]: G.MyParcelBe,
	[U.MyParcelIt]: G.MyParcelIt,
	[U.DeliverDutch]: G.DeliverDutch,
	[U.PostNlPlugin]: G.PostNlPlugin
}, un = (e) => ln[e], dn = {
	[G.MyParcelNl]: U.MyParcel,
	[G.MyParcelBe]: U.SendMyParcel,
	[G.MyParcelIt]: U.MyParcelIt
}, fn = {
	[G.MyParcelNl]: {
		[T.HomeCountry]: [
			0,
			1e4,
			25e3,
			5e4,
			1e5,
			15e4,
			2e5,
			25e4,
			3e5,
			35e4,
			4e5,
			45e4,
			5e5
		],
		[a.Netherlands]: [
			0,
			1e4,
			25e3,
			5e4,
			1e5,
			15e4,
			2e5,
			25e4,
			3e5,
			35e4,
			4e5,
			45e4,
			5e5
		],
		[T.Eu]: [
			0,
			5e3,
			5e4
		],
		[T.Row]: [
			0,
			5e3,
			5e4
		],
		[a.Belgium]: [
			0,
			1e4,
			25e3,
			5e4,
			1e5,
			15e4,
			2e5,
			25e4,
			3e5,
			35e4,
			4e5,
			45e4,
			5e5
		]
	},
	[G.MyParcelBe]: {
		[T.HomeCountry]: [0, 5e4],
		[a.Belgium]: [0, 5e4],
		[a.Netherlands]: [
			0,
			1e4,
			25e3,
			5e4,
			1e5,
			15e4,
			2e5,
			25e4,
			3e5,
			35e4,
			4e5,
			45e4,
			5e5
		],
		[T.Eu]: [
			0,
			5e3,
			5e4
		],
		[T.Row]: [
			0,
			5e3,
			5e4
		]
	}
}, pn = { [G.MyParcelBe]: {
	[T.HomeCountry]: [
		0,
		5e4,
		25e4,
		5e5
	],
	[a.Belgium]: [
		0,
		5e4,
		25e4,
		5e5
	],
	[T.Eu]: [
		0,
		5e4,
		25e4,
		5e5
	],
	[T.Row]: [
		0,
		5e4,
		25e4,
		5e5
	]
} }, q = { [G.MyParcelNl]: {
	[T.HomeCountry]: [
		0,
		5e4,
		1e5,
		15e4,
		2e5,
		25e4,
		3e5,
		35e4,
		4e5,
		45e4,
		5e5
	],
	[a.Netherlands]: [
		0,
		5e4,
		1e5,
		15e4,
		2e5,
		25e4,
		3e5,
		35e4,
		4e5,
		45e4,
		5e5
	],
	[T.Eu]: [
		0,
		5e4,
		1e5,
		15e4,
		2e5,
		25e4,
		3e5,
		35e4,
		4e5,
		45e4,
		5e5
	],
	[T.Row]: [
		0,
		5e4,
		1e5,
		15e4,
		2e5,
		25e4,
		3e5,
		35e4,
		4e5,
		45e4,
		5e5
	]
} }, J = { [G.MyParcelNl]: {
	[T.HomeCountry]: [
		0,
		1e4,
		25e3,
		5e4,
		1e5,
		15e4,
		2e5,
		25e4,
		3e5,
		35e4,
		4e5,
		45e4,
		5e5
	],
	[a.Netherlands]: [
		0,
		1e4,
		25e3,
		5e4,
		1e5,
		15e4,
		2e5,
		25e4,
		3e5,
		35e4,
		4e5,
		45e4,
		5e5
	],
	[a.Belgium]: [
		0,
		1e4,
		25e3,
		5e4,
		1e5,
		15e4,
		2e5,
		25e4,
		3e5,
		35e4,
		4e5,
		45e4,
		5e5
	],
	[a.Luxembourg]: [
		0,
		1e4,
		25e3,
		5e4,
		1e5,
		15e4,
		2e5,
		25e4,
		3e5,
		35e4,
		4e5,
		45e4,
		5e5
	]
} }, mn = {
	[t.Bpost]: pn,
	[t.PostNl]: fn,
	[t.DhlForYou]: q,
	[t.DhlParcelConnect]: q,
	[t.DhlEuroPlus]: q,
	[t.Ups]: J,
	[t.UpsStandard]: J,
	[t.UpsExpressSaver]: J
}, hn = {
	a4: "A4",
	a6: "A6"
}, gn = {
	topLeft: "2",
	topRight: "4",
	bottomLeft: "1",
	bottomRight: "3"
}, Y = {
	Package: 1,
	Mailbox: 2,
	Letter: 3,
	DigitalStamp: 4,
	Pallet: 5,
	PackageSmall: 6,
	Envelope: 7
}, X = {
	Package: "package",
	Mailbox: "mailbox",
	Letter: "letter",
	DigitalStamp: "digital_stamp",
	Pallet: "pallet",
	PackageSmall: "package_small",
	Envelope: "envelope"
}, _n = {
	[Y.Package]: X.Package,
	[Y.Mailbox]: X.Mailbox,
	[Y.Letter]: X.Letter,
	[Y.DigitalStamp]: X.DigitalStamp,
	[Y.Pallet]: X.Pallet,
	[Y.PackageSmall]: X.PackageSmall,
	[Y.Envelope]: X.Envelope
}, vn = (e) => _n[e], yn = {
	[X.Package]: Y.Package,
	[X.Mailbox]: Y.Mailbox,
	[X.Letter]: Y.Letter,
	[X.DigitalStamp]: Y.DigitalStamp,
	[X.Pallet]: Y.Pallet,
	[X.PackageSmall]: Y.PackageSmall,
	[X.Envelope]: Y.Envelope
}, bn = (e) => yn[e], Z = {
	DIGITAL_STAMP: "DIGITAL_STAMP",
	ENVELOPE: "ENVELOPE",
	MAILBOX: "MAILBOX",
	PACKAGE: "PACKAGE",
	PALLET: "PALLET",
	SMALL_PACKAGE: "SMALL_PACKAGE",
	UNFRANKED: "UNFRANKED"
}, Q = {
	[Y.Package]: Z.PACKAGE,
	[Y.Mailbox]: Z.MAILBOX,
	[Y.Letter]: Z.UNFRANKED,
	[Y.DigitalStamp]: Z.DIGITAL_STAMP,
	[Y.Pallet]: Z.PALLET,
	[Y.PackageSmall]: Z.SMALL_PACKAGE,
	[Y.Envelope]: Z.ENVELOPE
}, xn = (e) => Q[e], $ = {
	PendingConcept: 1,
	PendingRegistered: 2,
	EnrouteHandedToCarrier: 3,
	EnrouteSorting: 4,
	EnrouteDistribution: 5,
	DeliveredAtCustoms: 6,
	DeliveredAtRecipient: 7,
	DeliveredReadyForPickup: 8,
	DeliveredPackagePickedUp: 9,
	DeliveredReturnShipmentReadyForPickup: 10,
	DeliveredReturnShipmentPackagePickedUp: 11,
	PrintedUnpaidLabel: 12,
	PrintedLetter: 12,
	Credited: 13,
	PrintedStamp: 14,
	PrintedDigitalStamp: 14,
	Expired: 16,
	Cancelled: 17,
	PrintedUntrackedShipment: 18,
	DeliveredAtAgreedLocation: 19,
	InactiveConcept: 30,
	InactiveRegistered: 31,
	InactiveEnrouteHandedToCarrier: 32,
	InactiveEnrouteSorting: 33,
	InactiveEnrouteDistribution: 34,
	InactiveEnrouteCustoms: 35,
	InactiveDeliveredAtRecipient: 36,
	InactiveDeliveredReadyForPickup: 37,
	InactiveDeliveredPackagePickedUp: 38,
	CreditRejected: 100,
	CreditApproved: 101
}, Sn = [$.PendingConcept, $.PendingRegistered], Cn = [
	$.EnrouteHandedToCarrier,
	$.EnrouteSorting,
	$.EnrouteDistribution,
	$.DeliveredAtCustoms
], wn = [
	$.DeliveredAtRecipient,
	$.DeliveredPackagePickedUp,
	$.DeliveredReturnShipmentPackagePickedUp,
	$.DeliveredAtAgreedLocation
], Tn = [$.PrintedLetter, $.PrintedDigitalStamp], En = [
	$.InactiveConcept,
	$.InactiveRegistered,
	$.InactiveEnrouteHandedToCarrier,
	$.InactiveEnrouteSorting,
	$.InactiveEnrouteDistribution,
	$.InactiveEnrouteCustoms,
	$.InactiveDeliveredAtRecipient,
	$.InactiveDeliveredReadyForPickup,
	$.InactiveDeliveredPackagePickedUp
], Dn = {
	Passed: "passed",
	Failed: "failed",
	Error: "error",
	Pending: "pending"
};
//#endregion
//#region src/type-guards/isEvent.ts
function On(e) {
	return e instanceof Event;
}
//#endregion
//#region src/type-guards/isHtmlElement.ts
function kn(e) {
	return e instanceof HTMLElement;
}
//#endregion
//#region src/type-guards/isCarrier.ts
var An = (e) => Object.values(n).includes(e), jn = (e) => Object.values(t).includes(e);
//#endregion
export { oe as ALL_COUNTRIES, ge as AccountMessageSpecifics, ye as AccountStatus, xe as AddressType, Ce as AnalyticsDashboardCategory, Se as AnalyticsDashboardSlug, Rt as BUNDLES_IDS_TO_NAMES, A as BUNDLES_NAMES_TO_IDS, Ae as BillingCycle, Oe as BillingMethodId, ke as BillingStatus, Me as BillingVatType, ze as BpostBracketName, pn as BpostInsuranceAmounts, O as BundlesProductId, k as BundlesTierName, se as COUNTRIES_WITHOUT_POSTAL_CODE, t as CarrierId, te as CarrierIdToName, r as CarrierIdToNameV2, n as CarrierName, i as CarrierNameToId, e as CarrierOptionsLabel, G as ConfigKey, dn as ConfigKeyToPlatformId, He as ContractType, a as Country, ue as CourierProductId, Ye as Currency, jt as CustomsDeclarationContents, Ze as DAYS_OF_WEEK_IDS_TO_NAMES, Xe as DAYS_OF_WEEK_NAMES_TO_IDS, m as DaysOfWeek, h as DaysOfWeekName, o as DeliveryTypeId, de as DeliveryTypeIdToName, u as DeliveryTypeIdToNameV2, s as DeliveryTypeName, l as DeliveryTypeNameToId, c as DeliveryTypeNameV2, Ie as DhlEuroplusBracketName, Fe as DhlForYouBracketName, q as DhlInsuranceAmounts, Le as DhlParcelConnectBracketName, w as Dimension, wt as DimensionFactor, Ct as DimensionName, je as DirectDebitType, ee as DiscontinuedCarriers, Re as DpdBracketName, ce as ERS_COUNTRIES, ae as EU_COUNTRIES, Et as EcommerceSalesChannels, et as EmailTemplateType, _ as ExternalProviderId, y as ExternalProviderIdToName, v as ExternalProviderName, b as ExternalProviderNameToId, g as FileSizeUnits, tt as FileType, rt as FulfilmentMode, d as FulfilmentPartnerId, p as FulfilmentPartnerIdToName, f as FulfilmentPartnerName, be as Gender, it as ImageError, ot as InsightsDashboardCategory, at as InsightsDashboardSlug, mn as InsuranceAmounts, lt as InvitationStatus, ft as InvoiceOpenStatus, pt as InvoicePaidStatus, ut as InvoiceReminderName, x as InvoiceStatus, dt as InvoiceStatusIdToNameMap, S as InvoiceStatusName, mt as InvoiceTab, ht as InvoiceType, En as LegacyShipmentStatuses, N as MY_ANALYTICS_IDS_TO_NAMES, P as MY_ANALYTICS_NAMES_TO_IDS, L as MY_CONTRACTS_IDS_TO_NAMES, R as MY_CONTRACTS_NAMES_TO_IDS, V as MY_ORDERS_IDS_TO_NAMES, H as MY_ORDERS_NAMES_TO_IDS, we as MandateStatus, Te as MandateTransactionStatus, Ee as MandateTransactionType, j as MyAnalyticsProductId, M as MyAnalyticsTierName, F as MyContractsProductId, I as MyContractsTierName, z as MyOrdersProductId, B as MyOrdersTierName, ve as MyReturnsStatus, vt as NotificationLocation, _t as NotificationSize, gt as NotificationVariant, le as PUDO_COUNTRIES, Y as PackageTypeId, _n as PackageTypeIdToName, Q as PackageTypeIdToNameV2, X as PackageTypeName, yn as PackageTypeNameToId, hn as PaperSize, bt as PayingParty, We as PaymentStatusName, U as PlatformId, K as PlatformIdToName, W as PlatformName, Ue as PortalEvents, Pe as PostNlBracketName, fn as PostNlInsuranceAmounts, gn as PrintLabelPosition, Tt as ProductName, De as ProductType, T as Region, on as RoleType, _e as ShipmentLabel, At as ShipmentOptionName, Z as ShipmentPackageTypeV2, $ as ShipmentStatus, wn as ShipmentStatusDelivered, Cn as ShipmentStatusEnroute, Dt as ShipmentStatusId, Ke as ShipmentStatusNumber, Sn as ShipmentStatusPending, Tn as ShipmentStatusPrinted, kt as ShipmentTransactionStatus, Ot as ShipmentTypeId, Mt as ShippingRuleType, Je as SocialPlatforms, qe as SocialWidgetType, yt as SortOrder, Zt as SubType, Vt as SubscriptionFeature, Ve as SubscriptionName, Yt as SubscriptionStatus, Pt as SubscriptionTierIdToName, Ft as SubscriptionTierNameToId, Jt as SubscriptionType, en as SupportCaseInteractionType, Xt as SupportCaseStatus, Qt as SupportCaseType, $t as SupportLanguages, tn as SystemMessageType, nn as SystemNotificationType, D as TierId, E as TierName, Nt as TierRange, Ge as TrackTraceShipmentStatus, rn as TransactionStatus, an as TransactionType, Be as UpsBracketName, J as UpsInsuranceAmounts, Dn as VettingStatus, sn as WebhookType, C as Weight, St as WeightFactor, xt as WeightName, It as convertTierIdToName, Lt as convertTierNameToId, nt as fileSizeUnits, jn as isCarrierId, An as isCarrierName, On as isEvent, kn as isHtmlElement, Bt as toBundlesProductId, zt as toBundlesTierName, ie as toCarrierId, ne as toCarrierName, re as toCarrierNameV2, un as toConfigKey, $e as toDayOfWeekId, Qe as toDayOfWeekName, pe as toDeliveryTypeId, fe as toDeliveryTypeName, me as toDeliveryTypeNameV2, ct as toExternalProviderId, st as toExternalProviderName, he as toFulfilmentPartnerName, Ut as toMyAnalyticsProductId, Ht as toMyAnalyticsTierName, Wt as toMyContractsTierName, qt as toMyOrdersProductId, Kt as toMyOrdersTierName, bn as toPackageTypeId, vn as toPackageTypeName, xn as toPackageTypeNameV2, cn as toPlatformName, Gt as toSubscriptionProductId, Ne as vatTariffPercentage };

//# sourceMappingURL=index.js.map